import React from 'react';
import AdContainer from '../../../../components/ads';
import * as S from './styles';

import { LayoutMode } from 'src/components/layout-buttons/types';
import type { AdsLayoutConfig } from './types';

type AdsProps = {
  offersLength: number;
  layout: LayoutMode;
  layoutConfig?: AdsLayoutConfig;
  scaleBase?: string;
  async?: boolean;
};

const DEFAULT_LAYOUT_CONFIG: AdsLayoutConfig = {
  [LayoutMode.GRID]: {
    panorama_extra: {
      show: true,
      row: 2,
    },

    dubbelpanorama1: {
      show: true,
      row: 2,
    },

    dubbelpanorama2: {
      show: true,
      row: 8,
    },
  },

  [LayoutMode.LIST]: {
    panorama_extra: {
      show: true,
      row: 2,
    },

    dubbelpanorama1: {
      show: true,
      row: 2,
    },

    dubbelpanorama2: {
      show: true,
      row: 8,
    },
  },
  [LayoutMode.COMPACT_LIST]: {
    panorama_extra: {
      show: true,
      row: 2,
    },

    dubbelpanorama1: {
      show: true,
      row: 2,
    },

    dubbelpanorama2: {
      show: true,
      row: 8,
    },
  },
};

const Ads = ({
  offersLength,
  layout,
  layoutConfig,
  scaleBase,
  async,
}: AdsProps) => {
  return (
    <>
      {offersLength > 4 && (
        <Advert
          scalable
          scaleBase={scaleBase && `.${scaleBase}`}
          scaleOrigin="left center"
          placement="panorama_extra"
          format="panorama_1_wde"
          min={0}
          max={10000}
          layout={layout}
          layoutConfig={layoutConfig}
          async={async}
        />
      )}
      {offersLength > 2 && (
        <Advert
          placement="dubbelpanorama1"
          format="panorama_1"
          min={0}
          max={860}
          layout={layout}
          layoutConfig={layoutConfig}
          async={async}
        />
      )}
      {offersLength > 18 && (
        <Advert
          placement="dubbelpanorama2"
          format="panorama_2"
          min={0}
          max={860}
          triggerPoint={100}
          layout={layout}
          layoutConfig={layoutConfig}
          async={async}
        />
      )}
    </>
  );
};

const getDisplay = (placement: AdvertProps['placement']) => {
  switch (placement) {
    case 'panorama_extra':
      return 'desktop';
    case 'dubbelpanorama1':
    case 'dubbelpanorama2':
      return 'mobile';
    default:
      return '';
  }
};

type AdvertProps = {
  format: 'panorama_1_wde' | 'panorama_1' | 'panorama_2';
  min: number;
  max: number;
  placement: 'panorama_extra' | 'dubbelpanorama1' | 'dubbelpanorama2';
  async?: boolean;
  scalable?: boolean;
  scaleBase?: string;
  scaleOrigin?: string;
  triggerPoint?: number;
  layout: LayoutMode;
  layoutConfig?: AdsLayoutConfig;
};

const Advert = ({
  format,
  min,
  max,
  placement,
  scalable = false,
  scaleBase,
  scaleOrigin,
  triggerPoint,
  layout,
  layoutConfig = {},
  async,
}: AdvertProps) => {
  const display = getDisplay(placement);
  const config = {
    ...DEFAULT_LAYOUT_CONFIG,
    ...layoutConfig,
  };

  const placementConfig = config[layout][placement];

  if (!placementConfig.show) {
    return null;
  }

  return (
    <S.Advert row={placementConfig.row} key={placement} $display={display}>
      <AdContainer
        scalable={scalable}
        scaleBase={scaleBase}
        scaleOrigin={scaleOrigin}
        placement={placement}
        format={format}
        min={min}
        max={max}
        triggerPoint={triggerPoint}
        async={async}
      />
    </S.Advert>
  );
};

export { Ads, Advert };
